import Button from 'components/common/Button';
import DiscountTag from 'components/common/DiscountTag';
import StrikethroughSkeleton from 'components/common/StrikethroughSkeleton';
import Text from 'components/common/Text';
import { displayFunnelServingsText } from 'helpers/servings';

import PickMoreMealsModal from './PickMoreMealsModal';

const ClosedMobileOrderSummary = ({
  orderSummary,
  toggleOrderSummary,
  handleOnClick,
  totalServings,
  user,
  modalState,
  setModalState,
  isSubmitting,
  onContinue,
  showDiscount,
}) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-0 h-40 rounded-md bg-tempo-navy-90 pt-2 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.10)]">
      <div className="flex justify-between px-4 pb-2">
        <Text className="textMd mb-auto text-tempo-blue-10">
          {displayFunnelServingsText({ servings: totalServings, increment: 1 })} /{' '}
          {user?.weeklyMeals} meals selected
        </Text>
        <Button
          className="textSm text-white mb-0 border-none p-0 underline"
          variation="Ghost"
          onClick={toggleOrderSummary}
        >
          View Box
        </Button>
      </div>
      <div className="h-full w-full bg-white-100 px-4">
        <div className="flex items-center justify-between pt-2">
          <div className="flex gap-2">
            {showDiscount ? (
              <StrikethroughSkeleton
                strikethroughText={orderSummary.subtotalFormatted}
                textDisplayed={orderSummary.promo.subtotalFormatted}
                textDisplayedClassName="mr-1 text-tempo-navy-100 h2 text-2xl"
                ariaLabel="subtotal"
                className="order-last"
                containerClassNames="flex items-end"
              />
            ) : (
              <Text
                htmlElement="span"
                brandStylesOverrides="h2 text-2xl"
                className="mr-1 text-tempo-navy-100"
              >
                {orderSummary.subtotalFormatted}
              </Text>
            )}
          </div>
          {showDiscount && (
            <DiscountTag
              discountText={orderSummary.promo.displayedDiscount}
              spanClassNames="flex-none mr-0"
            />
          )}
        </div>
        <div className="pt-2">
          <Button type="submit" onClick={handleOnClick} className="w-full" disabled={isSubmitting}>
            Continue to Billing
          </Button>
          <PickMoreMealsModal
            servings={user?.servings}
            totalServings={totalServings}
            isOpen={modalState.isOpen}
            onDismiss={() => setModalState({ isOpen: false, type: null })}
            type={modalState.type}
            isSubmitting={isSubmitting}
            onContinue={onContinue}
          />
        </div>
      </div>
    </div>
  );
};

ClosedMobileOrderSummary.propTypes = {
  toggleOrderSummary: PropTypes.func.isRequired,
  handleOnClick: PropTypes.func.isRequired,
  totalServings: PropTypes.number.isRequired,
  user: PropTypes.shape({
    weeklyMeals: PropTypes.number,
    servings: PropTypes.number,
  }),
  orderSummary: PropTypes.shape({
    subtotalFormatted: PropTypes.string,
    promoApplied: PropTypes.bool,
    promo: PropTypes.shape({
      subtotalFormatted: PropTypes.string,
    }),
  }),
  modalState: PropTypes.shape({
    isOpen: PropTypes.bool.isRequired,
    type: PropTypes.string,
  }).isRequired,
  setModalState: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  onContinue: PropTypes.func,
  showDiscount: PropTypes.bool,
};

export default ClosedMobileOrderSummary;
